const namespaced = true

const state = {
  orderItemId:0,
}

const mutations = {
  updateOrderItemId(state, id) { // Namespaced
    state.orderItemId = id
  },
}

export default {
  namespaced,
  state,
  mutations,
}
